import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'brand-pagekit', 'IconBrandPagekit', [["path",{"d":"M12.077 20h-5.077v-16h11v14h-5.077","key":"svg-0"}]]);